import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Heading from '../Heading/Heading'
import ButtonDownload from '../ButtonDownload/ButtonDownload'
import { deviceMax } from '../../theme/breakpoints'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import Button from '../Button/Button'

export const StyledBlock = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: start;
  display: flex;
  background-color: ${({ theme }) => theme.colors.unique.transparent};
  @media ${deviceMax.tablet} {
    padding: 0 ${pxToRem(20)};
  }
`

export const StyledRichText = styled(CKEditorContent)`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH5};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH5};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  text-align: ${({ $alignment }) => ($alignment ? $alignment : 'left')};
  color: ${({ theme }) => theme.colors.opacity.black70};
  figure {
    margin-bottom: ${pxToRem(20)};
  }
`

export const StyledDivRichText = styled.div`
  margin: ${pxToRem(10)} 0 0 0;
  width: 100%;
  max-width: ${({ $hasDocument }) =>
    $hasDocument ? `${pxToRem(792)}` : 'none'};
  flex: 2;
  @media ${deviceMax.tablet} {
    max-width: 100%;
    margin: ${pxToRem(10)} 0;
  }
`

export const StyledHeading = styled(Heading)`
  margin-bottom: ${pxToRem(10)};
`

export const StyledButtonDownload = styled(ButtonDownload)`
  flex-grow: 0;
  margin-right: ${pxToRem(10)};
  width: ${pxToRem(230.13)};
  @media ${deviceMax.mobileL} {
    width: calc(100% - ${pxToRem(40)});
    margin: ${pxToRem(5)} ${pxToRem(20)};
  }
`

export const StyledDocuments = styled.div`
  flex-direction: row;
  display: flex;
  @media ${deviceMax.mobileL} {
    flex-direction: column;
    margin-bottom: ${pxToRem(15)};
  }
`

export const StyledCtaButton = styled(Button)`
  justify-content: center;
  @media ${deviceMax.mobileM} {
    width: 100%;
  }
`
